/**
 * @module: 效率监控相关utils函数
 * @author: Teacher Tang
 * @date: 2019-11-19 16:44:13
 */

export default {
  /** 获取正负前缀 */
  getRatio(num: number) {
    if (num > 0) {
      return "+" + num + '%';
    } else if (num < 0) {
      return num + '%';
    }
    return '--'
  },
  /** 获取环比或同比显示 */
  getPreTip(reportDay: boolean | string, weekName: string) {
    return weekName === '本周' && !reportDay ? '同比' : '环比'
  },
  /** 获取样式 */
  getRatioClass(num: number) {
    if (num > 0) {
      return "up";
    } else if (num < 0) {
      return 'down';
    }
    return ''
  },
  /** 获取时间字符串 */
  getPreStr(week: string, reportDay: boolean | string) {
    if (week === "week") {
      return reportDay ? "今天" : "本周";
    }
    return reportDay ? "昨天" : "上周";
  }
}
